<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Suppliers</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="primary" small to="/new-supplier">
              <v-icon left dark>mdi-plus</v-icon>New Supplier
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn class="float-right" color="accent" text @click="suppliersDialog = true">
              <v-icon left>mdi-upload</v-icon>Import Suppliers
            </v-btn>
          </v-col>

          <v-col cols="12" class="mt-2">
             <v-btn color="accent" small text @click="fixSupplierBalance">
              Fix Supplier Balance
            </v-btn>
            </v-col>
        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="text--primary subtitle-2">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="suppliers" :search="search"
              :mobile-breakpoint="zeroValue">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/supplier/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- disable template -->
              <template v-slot:item.disable="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text>
                  <v-icon left>mdi-close</v-icon>Disable Supplier
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- suppliers dialog -->
          <v-dialog v-model="suppliersDialog" max-width="650px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Import Suppliers</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="suppliersDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>

                    <v-col cols="12" xs="12" md="12" class="mt-4">
                      <v-autocomplete autocomplete="off" hide-details dense outlined v-model="storeId" :items="stores"
                        label="Shop / Branch" item-text="Name" item-value="id"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
                        dense></v-file-input>
                    </v-col>

                    <v-col xs="12" sm="12" md="6" cols="12">
                      <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" @click="uploadExcel" :loading="loader">
                        <v-icon left>mdi-upload</v-icon>Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <v-dialog v-model="deleteDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="secondary" flat>
                <v-toolbar-title>Delete / Disable Supplier</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="deleteDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row class="text--primary subtitle-2">
                    <v-col cols="12">Are you sure you want to disable this supplier ?</v-col>
                    <v-col cols="12">
                      <span style="font-size: 20px">{{ selectedItem.Name }}</span>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="red" dark :loading="loader" @click="deleteSupplier">Yes, Disable</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    storeId: null,
    loader: false,
    deleteDialog: false,
    selectedItem: {},
    suppliersDialog: false,
    excelFile: null,
    zeroValue: 0,
    pageItems: 100,
    date: null,
    headers: [
      { text: "Code", value: "DocNum" },
      { text: "Supplier Name", value: "Name" },
      { text: "Phone", value: "PhoneNumber" },
      { text: "Email", value: "Email" },
      { text: "Pin No", value: "PinNo" },
      { text: "Action", value: "action" },
      { text: "Disable", value: "disable" }
    ],
    suppliers: [],
    stores: [],
    fields: {
      Name: "Name",
      PhoneNumber: "PhoneNumber"
    }
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    openDeleteModal(data) {
      this.selectedItem = data;
      this.deleteDialog = true;
    },
    deleteSupplier() {
      const url = `/suppliers/delete/${this.selectedItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    uploadExcel() {
      if (this.date == null) {
        this.$refs.snackbar.show("Please select date!", "red");
      } else {
        const data = new FormData();
        data.append("suppliersData", this.excelFile);
        data.append("date", this.date);

        var storeId = 0;
        if (this.storeId != null) {
          storeId = this.storeId;
        }

        data.append("store_id", storeId);
        // send request
        this.loader = true;
        const url = "/suppliers-import";
        const self = this;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.$refs.snackbar.show(
                "Suppliers imported successfully",
                "green"
              );
              self.loader = false;
              self.excelFile = null;
              self.suppliersDialog = false;
              self.getSuppliers();
            } else {
              self.loader = false;
              self.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
      }
      // end
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteCustomer() {
      const url = `/suppliers/delete/${this.selectedItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      var userId = localStorage.getItem("userId");
      const self = this;
      this.$store
        .dispatch("get", `/user-stores/${userId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fixSupplierBalance() {
      const url = `/fix-digrio-suppliers/95/235/3`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.$refs.snackbar.show(
              "Supplier balance fixed successfully",
              "green"
            );
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getSuppliers();
    this.getStores();
  }
};
</script>